import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'hooks/routes';
import { useIntercomChat } from 'hooks/common';
import { useGetBlockedState } from 'hooks/cache';
import { checkMessageInState, protectApiError } from 'utils/typeGuards';
import { QueryKeys } from 'constants/queryKeys';
import Button from 'components/Button';
import messages from './LoginBlocked.messages';
import styles from './LoginBlocked.module.css';

export default function LoginBlocked() {
  const queryClient = useQueryClient();
  const location = useLocation();

  const { toLogin } = useNavigate();

  const state = checkMessageInState(location.state);
  const { showChat, registerChat } = useIntercomChat();
  useEffect(() => {
    if (!state) toLogin();
    registerChat?.();
  }, []);

  const blockedState = useGetBlockedState();
  if (protectApiError(blockedState)) {
    queryClient.removeQueries(QueryKeys.userBlocked);
  }
  return (
    <div className={styles.loginBlocked}>
      <h1 className={styles.loginBlocked__title}>{state?.title}</h1>
      <p
        className={styles.loginBlocked__text}
        dangerouslySetInnerHTML={{ __html: state?.message }}
      />
      <Button onClick={showChat} className={styles.loginBlocked__button}>
        {messages.buttonText}
      </Button>
    </div>
  );
}
